import { getNavLabel, NAV_ITEMS } from "@/config/navigation";

const publicItems = NAV_ITEMS.filter((item) => item.publicHref);
const publicItem = (key) => publicItems.find((item) => item.key === key);
const navLink = (key) => {
  const item = publicItem(key);
  return item ? { key, label: getNavLabel(key, "en"), href: item.publicHref } : null;
};
const navLinks = (keys) => keys.map(navLink).filter(Boolean);

export const footerLinkGroups = [
  {
    category: "Product",
    links: navLinks(["home", "dailyBriefing", "weather", "navigation", "safety", "tools"]),
  },
  {
    category: "Discover",
    links: navLinks(["weather", "marinas", "destinations", "tools", "learn", "glossary", "regulations"]),
  },
  {
    category: "Legal",
    links: [
      { key: "privacy", label: "Privacy Policy", href: "/privacy" },
      { key: "terms", label: "Terms & Conditions", href: "/terms" },
      { key: "cookies", label: "Cookie Policy", href: "/cookies" },
      { key: "contact", label: "Contact", href: "/contact" },
    ],
  },
];